import { render, staticRenderFns } from "./AutocompletePoi.vue?vue&type=template&id=0a124938&scoped=true"
import script from "./AutocompletePoi.vue?vue&type=script&lang=js"
export * from "./AutocompletePoi.vue?vue&type=script&lang=js"
import style0 from "./AutocompletePoi.vue?vue&type=style&index=0&id=0a124938&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a124938",
  null
  
)

export default component.exports